import { type AppState } from 'src/redux/app/app.store'

export const selectNotes = (state: AppState) => state.notes.notes
